/* eslint-disable camelcase */
import User from './User';

type Student = User;

export const EmptyStudent: Student = {
  email: '',
  title: '',
  name: '',
  university_code: '',
  advisor: '',
  cmkl_id: '',
  first_name: '',
  first_term: '',
  id: '',
  program_id: '',
  programs: [],
  last_name: '',
  last_term: '',
  nickname: '',
  role: 0,
  roles: [],
  cie_dual_degree: false
};
export default Student;
